import React, { useEffect, useContext, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../../context/AppContext';
import { insertQuestion1 } from '../../db/indexedDb.js';
import { TIMEOUT, BANNER_STAY_TIME } from '../../config/index.js';

import pharmacistImage from '../../images/pharmacist.png';

import './question2.css';

// Import images as URLs
const footerBanner1 = require('../../images/banner1.jpeg');
const footerBanner2 = require('../../images/banner2.jpeg');

const Question2 = () => {
  const { response, setResponse } = useContext(AppContext);
  const [currentBannerIndex, setCurrentBannerIndex] = useState(0);

  const banners = [footerBanner1, footerBanner2];

  const bannerTimerRef = useRef(null);
  const timerRef = useRef(null);
  
  const resetTime = TIMEOUT;

  const navigate = useNavigate();

  function getCurrentDateTimeUTC() {
    const now = new Date();

    // Get UTC components
    const year = now.getUTCFullYear();
    const month = String(now.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-based, so add 1
    const day = String(now.getUTCDate()).padStart(2, '0');
    const hours = String(now.getUTCHours()).padStart(2, '0');
    const minutes = String(now.getUTCMinutes()).padStart(2, '0');
    const seconds = String(now.getUTCSeconds()).padStart(2, '0');

    // Combine into MySQL DATETIME format
    const dateTimeUTC = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    return dateTimeUTC;
  }

  const handleSubmitQuestion = (e, answerQ2) => {
    e.preventDefault();
    setResponse(prevState => ({
      ...prevState,
      question2: {
        ...prevState.question2,
        response_value: answerQ2,
        datetime_: getCurrentDateTimeUTC(),
      },
    }));
    resetTimer();
    navigate('/question3');
  };

  const handleBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    // Locking orientation is not needed in web, so this is omitted
  }, []);

  // Screen inactivity go back to home screen logic
  useEffect(() => {
    startTimer();

    // Clear the timer on unmount
    return () => {
      clearTimer();
    };
  }, []);

  const startTimer = () => {
    clearTimer();
    timerRef.current = setTimeout(() => {
      // Submit response before timeout
      const insertResponse1 = async () => {
        await insertQuestion1(response.question1.device_id, response.question1.response_value, response.question1.datetime_, {}, response.customer_feedback_id);
      };
      insertResponse1();

      navigate('/');
    }, resetTime); // 30 seconds
  };

  const clearTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
  };

  const resetTimer = () => {
    startTimer();
  };

  // footer banner rotation logic
  useEffect(() => {
    startBannerRotation();
    return () => {
      clearInterval(bannerTimerRef.current);
    };
  }, []);

  const startBannerRotation = () => {
    bannerTimerRef.current = setInterval(() => {
      setCurrentBannerIndex((prevIndex) => (prevIndex + 1) % banners.length);
    }, BANNER_STAY_TIME); // Change banner every 10 seconds
  };

  return (
    <div className="question2-container" onClick={resetTimer}>
      <div className="question2-subContainer">
        <div className="question2-textContainer">
          <div className="question2-text">Did you talk with Pharmacist Johnny Silvestri today?</div>
          <div className='question2-image-container'>
          <img className="question2-image" src={pharmacistImage} alt="Pharmacist Johnny Silvestri" />
          </div>
        </div>

        <div className="question2-buttonContainer">
          <button className="question2-button" onClick={(e) => handleSubmitQuestion(e, 'no')}>
            <div className="question2-no-text-container">
              <span class="question2-no-text">No &#10007;</span>
            </div>
          </button>
          <button className="question2-button" onClick={(e) => handleSubmitQuestion(e, 'yes')}>
            <div className="question2-yes-text-container">
              <span className="question2-yes-text">Yes &#10004;</span> 
            </div>
          </button>
        </div>
      </div>

        <div className='question2-footer-banner-container'>
          <img className='question2-footer-banner-img' src={banners[currentBannerIndex]} alt='Banner' />
        </div>

    </div>
  );
};

export default Question2;
